/**
 * Wrap wide tables from the CMS editor so they scroll inside the article column
 * instead of widening the page.
 *
 * The editor emits bare <table> with no classes and often an explicit pixel
 * width, so this cannot be done in CSS alone — the wrapper element does not
 * exist until we add it.
 *
 * NOTE: base_neo and faradeed_neo both have a version of this, and the two have
 * DRIFTED — one keys off `.editor_styles`, the other off `.ck_editor`. Here
 * there is one implementation, imported by both entry points, and the selector
 * is a parameter.
 */
import { qsa } from './dom.js';

export function setupResponsiveTables(rootSelector = '.article-body, .ck_editor') {
  for (const root of qsa(rootSelector)) {
    for (const table of qsa('table', root)) {
      // Idempotent: main.js and main-news.js could both run on a page, and a
      // second wrapper around the same table would nest scroll containers.
      if (table.parentElement?.classList.contains('table-scroll')) continue;

      const wrapper = document.createElement('div');
      wrapper.className = 'table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}
